import { h } from 'preact';
import style from './Button.css';

export default function Button({ children, ...props }) {
	return (
		<a class={style.button} {...props}>{children}</a>
	);
}
